import { useEffect, useState } from 'react'

/**
 * useScrollProgress 훅
 * @param targetAreaRef 스크롤 진행률을 구할 대상 영역의 ref
 * @returns 대상 영역에 대해 얼마나 스크롤을 진행했는지 소숫점을 제거한 0 ~ 100의 number로 반환합니다.
 */
const useScrollProgress = (targetAreaRef: React.RefObject<HTMLElement> | null) => {
	const [progress, setProgress] = useState(0)
	useEffect(() => {
		if (!targetAreaRef?.current) return undefined
		const { current: targetArea } = targetAreaRef
		const calculateProgress = () => {
			const { top, bottom } = targetArea.getBoundingClientRect()
			const targetHeight = Math.max(bottom - top - window.innerHeight, 0)
			const scrollTop = window.pageYOffset || document.documentElement.scrollTop
			const headerHeight = window.innerWidth < 768 ? 52 : 86
			const targetTop = top + scrollTop - headerHeight
			const scrollProgress = ((scrollTop - targetTop) / targetHeight) * 100
			setProgress(Math.round(Math.min(Math.max(scrollProgress, 0), 100)))
		}
		const handleScroll = () => {
			calculateProgress()
		}
		window.addEventListener('scroll', handleScroll)
		return () => {
			window.removeEventListener('scroll', handleScroll)
		}
	}, [targetAreaRef, targetAreaRef?.current])
	return progress
}

export default useScrollProgress
